import CreateInteractiveMaterialView from "@features/tools/view/interactive-materials-view/create-interactive-material-view";

const CreateInteractiveMaterial = () => {
  return <CreateInteractiveMaterialView />;
};

export default CreateInteractiveMaterial;
